import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { contentGeneratorConfigPopulatedSchema } from "@redotech/redo-model/content-generator-config/content-generator-config-definition";
import * as z from "zod/v4";

export const createContentGeneratorConfig = {
  name: "createContentGeneratorConfig" as const,
  input: z.object({ schemaType: z.enum(SchemaType) }),
  output: contentGeneratorConfigPopulatedSchema,
};
